<template>
    <div class="guardian-component">
        <card-title-component :title="firstname + ' ' + lastname" v-if="firstname"></card-title-component>
        <card-title-component :title="email" v-else></card-title-component>
        <div class="card-content">
            <div class="row">
                <div class="col">
                    {{index2}}
                    <b-form-group id="firstname-form-group"
                                  class="o-label"
                                  :label="$t('guardian.firstname')"
                                  label-for="firstname-input">
                        <b-form-input id="firstname-input"
                                      class="o-form"
                                      type="text"
                                      v-model="firstname"
                                      required
                                      :placeholder="$t('guardian.firstname')"
                                      disabled>
                        </b-form-input>
                    </b-form-group>
                </div>
                <div class="col">
                    <b-form-group id="lastname-form-group"
                                  class="o-label"
                                  :label="$t('guardian.lastname')"
                                  label-for="lastname-input">
                        <b-form-input id="lastname-input"
                                      class="o-form"
                                      type="text"
                                      v-model="lastname"
                                      required
                                      :placeholder="$t('guardian.lastname')"
                                      disabled>
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="address-form-group"
                                  class="o-label"
                                  :label="$t('guardian.address')"
                                  label-for="address-input">
                        <b-form-input id="address-input"
                                      class="o-form"
                                      type="text"
                                      v-model="address"
                                      required
                                      :placeholder="$t('guardian.address')"
                                      disabled>
                        </b-form-input>
                    </b-form-group>
                </div>
                <div class="col">
                    <b-form-group id="address-extra-line-form-group"
                                  class="o-label"
                                  :label="$t('guardian.addressExtraInformation')"
                                  label-for="address-extra-line-input">
                        <b-form-input id="address-extra-line-input"
                                      class="o-form"
                                      type="text"
                                      v-model="extraAddressLine"
                                      required
                                      :placeholder="$t('guardian.addressExtraInformation')"
                                      disabled>
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="zipcode-form-group"
                                  class="o-label"
                                  :label="$t('guardian.zipcode')"
                                  label-for="zipcode-input">
                        <b-form-input id="firstname-input"
                                      class="o-form"
                                      type="text"
                                      v-model="zipcode"
                                      required
                                      :placeholder="$t('guardian.zipcode')"
                                      disabled>
                        </b-form-input>
                    </b-form-group>
                </div>
                <div class="col">
                    <b-form-group id="lastname-form-group"
                                  class="o-label"
                                  :label="$t('guardian.city')"
                                  label-for="city-input">
                        <b-form-input id="city-input"
                                      class="o-form"
                                      type="text"
                                      v-model="city"
                                      required
                                      :placeholder="$t('guardian.city')"
                                      disabled>
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="email-form-group"
                                  class="o-label"
                                  :label="$t('guardian.email')"
                                  label-for="email-input">
                        <b-form-input id="email-input"
                                      class="o-form"
                                      type="text"
                                      v-model="email"
                                      required
                                      :placeholder="$t('guardian.email')"
                                      disabled>
                        </b-form-input>
                    </b-form-group>
                </div>
                <div class="col">
                    <b-form-group id="mobile-form-group"
                                  class="o-label"
                                  :label="$t('guardian.mobile')"
                                  label-for="mobile-input">
                        <b-form-input id="mobile-input"
                                      class="o-form"
                                      type="text"
                                      v-model="mobile"
                                      required
                                      :placeholder="$t('guardian.mobile')"
                                      disabled>
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="phone-form-group"
                                  class="o-label"
                                  :label="$t('guardian.phone')"
                                  label-for="phone-input">
                        <b-form-input id="phone-input"
                                      class="o-form"
                                      type="text"
                                      v-model="phone"
                                      required
                                      :placeholder="$t('guardian.phone')"
                                      disabled>
                        </b-form-input>
                    </b-form-group>
                </div>
                <div class="col">
                    <b-form-group id="website-form-group"
                                  class="o-label"
                                  :label="$t('guardian.website')"
                                  label-for="website-input">
                        <b-form-input id="website-input"
                                      class="o-form"
                                      type="text"
                                      v-model="website"
                                      required
                                      :placeholder="$t('guardian.website')"
                                      disabled>
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CardTitleComponent from '../ui/card/CardTitleComponent'

    export default {
        name: 'Guardian',
        components: {
            'card-title-component': CardTitleComponent
        },
        props: ['firstname', 'lastname', 'address', 'extraAddressLine', 'zipcode', 'city', 'email', 'mobile', 'phone', 'website', 'index2'],
        methods: {}
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/guardian/GuardianComponent.vue